import { matchPath } from 'react-router-dom';

export const RoutePath = {
  about: '/about',
  browse: '/browse',
  browseCollection: '/browse/:collectionId',
  collection: '/collection/:collectionId',
  deviceLogin: '/device-login',
  deviceLogout: '/device-logout',
  home: '/',
  linkAccountCallback: '/link-account-callback',
  login: '/login',
  logout: '/logout',
  movie: '/movie/:brandId',
  myHub: '/my-hub/:sectionId',
  myHubLanding: '/myhub',
  myHubManageDevices: '/my-hub/manage-devices',
  myHubManagePackages: '/my-hub/manage-packages',
  package: '/package/:offerId',
  profile: '/profile/manage',
  redirect: '/redirect',
  register: '/register',
  search: '/search',
  show: '/show/:brandId',
  tvGuide: '/tv-guide/:channelId?',
  watch: '/watch/:brandId/:episodeId?',
  watchTv: '/watch-tv/:channelId?',
};

export const isHomePagesPath = (pathname: string) => {
  const HomePagesPath = [RoutePath.home, RoutePath.watchTv];
  return HomePagesPath.some(homePage => {
    const match = matchPath(pathname, {
      path: homePage,
      exact: true,
    });
    return match?.isExact;
  });
};

export const isProfilePage = (pathname: string) => {
  const match = matchPath(pathname, {
    path: RoutePath.profile,
    exact: true,
  });
  return match?.isExact;
};
export const isNonDefaultPage = (pathname: string) => {
  // non default page is the one with no default header and footer
  const NonDefaultPage = [RoutePath.myHub];
  return NonDefaultPage.some(path => {
    const match = matchPath(pathname, {
      path,
      exact: true,
    });
    return match?.isExact;
  });
};
